import template from "./bCasemanMenu.html";

export function bCasemanMenuDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bCasemanMenuController,
    controllerAs: 'bCasemanMenu',
    bindToController: true,
    scope: {
      user: "=?",
      teamsConfig: "=",
      teamsErp: "=",
      usersConfig: "=",
      clientsConfig: "=",
      clientsNewConfig: "=",
      processGroupsConfig: "=",
      projectConfig: '=',
      matching: "=",
      sync: "=",
      integrationSettings: "="
    }
  };

  return directive;
}

class bCasemanMenuController {
  constructor(Auth) {
    'ngInject';
    this.canImportIncomeFromCaseman = false;

    this.$onInit = () => {
      this.userInfo = angular.fromJson(localStorage.getItem("ngStorage-roedl-session"));
      ((!this.userInfo.preferences || !this.userInfo.preferences.featureFlags) ?
        Auth.authorize().then(user => !!user.preferences.featureFlags.find(ff => ff === "CASEmanIncomeImport")) :
        Promise.resolve(!!this.userInfo.preferences.featureFlags.find(ff => ff === "CASEmanIncomeImport")))
        .then(res => this.canImportIncomeFromCaseman = res);
    };
  }

  back() {
    window.close();
  }
}
